import {
  React,
  Route,
  Switch,
  useEffect,
  CSSTransition,
  TransitionGroup,
  storage,
  Fragment,
  Loadable
} from './libraries'
// import appRoutes from './routes/appRoutes'
import { ScrollToTop, SpinnerLoading } from './components'
import { api } from './helpers'
import './App.css'

// const Loading = () => null

const Home = Loadable({
  loader: () => import('./containers/HomeContainer'),
  loading: SpinnerLoading
})

const About = Loadable({
  loader: () => import('./pages/About'),
  loading: SpinnerLoading
})

const Article = Loadable({
  loader: () => import('./containers/ArticleContainer'),
  loading: SpinnerLoading
})

const Peraturan = Loadable({
  loader: () => import('./pages/PeraturanPemilu'),
  loading: SpinnerLoading
})

const Syarat = Loadable({
  loader: () => import('./pages/SyaratBalon'),
  loading: SpinnerLoading
})

const Pendaftaran = Loadable({
  loader: () => import('./pages/RegisterMember'),
  loading: SpinnerLoading
})

const Vote = Loadable({
  loader: () => import('./pages/Vote'),
  loading: SpinnerLoading
})

const Quisioner = Loadable({
  loader: () => import('./pages/Quisioner'),
  loading: SpinnerLoading
})

const QuisionerResult = Loadable({
  loader: () => import('./pages/QuisionerResult'),
  loading: SpinnerLoading
})

const Auth = Loadable({
  loader: () => import('./containers/AuthContainer'),
  loading: SpinnerLoading
})

const DetailArticle = Loadable({
  loader: () => import('./containers/DetailArticleContainer'),
  loading: SpinnerLoading
})

const NotFound = Loadable({
  loader: () => import('./pages/NotFound'),
  loading: SpinnerLoading
})

export const App = () => {

  const getAppToken = () => {
    const company = {
      company_name: 'fevci',
      comp_key: 'fevci123'
    }

    api.post('api/app_token', { company_name: company.company_name, comp_key: company.comp_key })
      .then(res => {
        const { data: appToken, success } = res.data
        if (success === true) {
          storage.setItem('app-token', JSON.stringify(appToken))
        } else {
          storage.removeItem('app-token')
        }
      })
  } 

  useEffect(() => {
    getAppToken()
  }, [getAppToken])

  return (
    <Route
      render={({ location }) => (
        <Fragment>
          <ScrollToTop />
          <TransitionGroup>
            <CSSTransition key={location.key} timeout={300} className='fade'>
              <Switch>
                <Route path='/' exact component={Home} />
                <Route path='/about' component={About} />
                <Route path='/article' component={Article} />
                <Route path='/article' component={Article} />
                <Route path='/detail/article/:id' exact component={DetailArticle} />
                <Route path='/peraturan-pemilu' component={Peraturan} />
                <Route path='/syarat-balon' component={Syarat} />
                <Route path='/register' component={Pendaftaran} />
                <Route path='/vote' component={Vote} />
                <Route path='/quisioner/:id' exact component={Quisioner} />
                <Route path='/quisioner/result/:id' component={QuisionerResult} />
                <Route path='/login' component={Auth} />
                <Route path='*' component={NotFound} />
              </Switch>
            </CSSTransition>
          </TransitionGroup>
        </Fragment>
      )}
    />
  )
}
